<div class="card mb-5">
  <div class="card-header">
    <h3>
      Plantillas de Parámetros de Productos

      <a (click)="creating = true" *ngIf="!creating">
        <i class="a-hover fa fa-plus"></i>
      </a>

      <a (click)="cancelForm()" *ngIf="creating">
        <i class="a-hover fa fa-subtract"></i>
      </a>
    </h3>
  </div>

  <div class="card-body">

    <div class="row mb-2" *ngIf="creating">
      <div class="col-12">
        <h5>{{ formTitle }}</h5>
      </div>
    </div>

    <div class="row align-items-end mb-4" *ngIf="creating">

      <div class="col form-group mb-4">
        <label class="form-label">
          Nombre de plantilla <span class="required">*</span>
        </label>
        <input
          type="text"
          class="form-control"
          [(ngModel)]="templateName"
          placeholder="Ej. Plantilla análisis de agua">
      </div>

      <div class="col form-group mb-4">
        <label class="form-label">
          Producto <span class="required">*</span>
        </label>

        <div class="input-group">
          <app-input-autocomplete
            [allBorderRadius]="true"
            [inputs]="inputs.product"
            [placeholder]="'Ingresa un producto'"
            [filterElements]="filterProducts"
            [typeElements]="'product-template'"
            (inputMethod)="writeProduct($event.event)"
            (changeStatus)="checkProduct($event.filterElement)"
            (getTitle)="
              $event.filterElement.title =
                $event.filterElement.code + ' - ' + $event.filterElement.name
            ">
          </app-input-autocomplete>
        </div>
      </div>

      <div class="col form-group mb-4">
        <label class="form-label">Parámetro</label>

        <div class="input-group">
          <app-input-autocomplete
            [allBorderRadius]="true"
            [inputs]="inputs.parameter"
            [placeholder]="'Ingresa un parámetro'"
            [filterElements]="filterCoasParameter"
            [typeElements]="'parameter-template'"
            (inputMethod)="writeParameter($event.event)"
            (changeStatus)="checkParameter($event.filterElement)"
            (getTitle)="
              $event.filterElement.title =
                $event.filterElement.parameter
            ">
          </app-input-autocomplete>
        </div>
      </div>

      <div class="col form-group mb-4">
        <button
          class="btn btn-success"
          (click)="saveTemplate()"
          [disabled]="loading || !verifyForm">

          <ng-container *ngIf="!loading">
            <i class="fa fa-floppy-disk"></i>
          </ng-container>

          <ng-container *ngIf="loading">
            <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
          </ng-container>

          {{ saveButtonText }}
        </button>

        <button
          class="btn btn-secondary ml-2"
          type="button"
          (click)="cancelForm()"
          [disabled]="loading">
          CANCELAR
        </button>
      </div>

      <div class="col-12" *ngIf="selectedParameters.length > 0">
        <h6>Parámetros agregados</h6>

        <table class="table table-sm table-bordered">
          <thead>
            <tr>
              <th>Parámetro</th>
              <th>Método</th>
              <th>Unidad</th>
              <th class="text-center">Acciones</th>
            </tr>
          </thead>

          <tbody>
            <tr *ngFor="let item of selectedParameters">
              <td>{{ item.parameter }}</td>
              <td>{{ item.method }}</td>
              <td>{{ item.units }}</td>
              <td class="text-center">
                <span class="a-hover text-danger" (click)="removeParameter(item)">
                  <i class="fa fa-trash"></i>
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

    </div>

    <div class="row" id="options-other-filters">
      <div class="col-sm form-group">
        <label for="filter" class="form-label">Filtrar</label>

        <div class="input-group input-group-sm">
          <input
            type="text"
            id="filter"
            [(ngModel)]="filterWord"
            (keydown.enter)="searching()"
            placeholder="Filtra plantilla o producto"
            name="filter"
            class="form-control">

          <button class="btn btn-primary" (click)="searching()">
            <i class="fa fa-search"></i>
          </button>
        </div>
      </div>
    </div>

    <div class="table table-responsive mt-3">
      <table class="table table-hover">
        <thead>
          <tr>
            <th>Plantilla</th>
            <th>Producto</th>
            <th>Cantidad Parámetros</th>
            <th class="text-center">Acciones</th>
          </tr>
        </thead>

        <tbody>
          <ng-container *ngFor="let item of filterTemplates">
            <tr>
              <td>{{ item.name }}</td>
              <td>{{ item.product?.code }} - {{ item.product?.name }}</td>
              <td>{{ item.parameters?.length || 0 }}</td>

              <td class="text-center">
                <span class="cursor-pointer mr-3" (click)="showParamsTemplate(item)">
                  <i
                    class="fa"
                    [ngClass]="showParams[item.id] ? 'fa-chevron-up' : 'fa-chevron-down'">
                  </i>

                  {{ showParams[item.id] ? 'Ocultar' : 'Mostrar' }}
                </span>

                <span class="a-hover text-info mr-3" (click)="initEditing(item)">
                  <i class="fa fa-edit"></i>
                </span>

                <div class="container-superposition d-inline-block" title="Eliminar">
                  <div class="element-superposition" *ngIf="item.showDelete">
                    <span>¿Está seguro que desea eliminar esta plantilla?</span>

                    <span class="a-container">
                      <span class="a-hover" (click)="showDeleteQuestion(item)">
                        <i class="fa fa-ban"></i> NO
                      </span>

                      <span class="a-hover text-danger" (click)="deleteTemplate(item)">
                        <i class="fa fa-trash"></i> SÍ
                      </span>
                    </span>
                  </div>

                  <span class="a-hover text-danger ml-2" (click)="showDeleteQuestion(item)">
                    <i *ngIf="!item.deleting" class="fa fa-trash"></i>

                    <span
                      *ngIf="item.deleting"
                      class="spinner-border spinner-border-sm"
                      aria-hidden="true">
                    </span>
                  </span>
                </div>
              </td>
            </tr>

            <tr *ngIf="showParams[item.id]">
              <td></td>

              <td colspan="3">
                <table class="table table-bordered table-subfamilies">
                  <thead>
                    <tr>
                      <th class="bg-th">Parámetro</th>
                      <th class="bg-th">Método</th>
                      <th class="bg-th">Unidad</th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr *ngFor="let parameter of item.parameters">
                      <td>{{ parameter.parameterData?.parameter }}</td>
                      <td>{{ parameter.parameterData?.method }}</td>
                      <td>{{ parameter.parameterData?.units }}</td>
                    </tr>

                    <tr *ngIf="!item.parameters || item.parameters.length === 0">
                      <td colspan="3" class="text-center">
                        Esta plantilla no tiene parámetros.
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </ng-container>

          <tr *ngIf="!loadingData && filterTemplates.length === 0">
            <td colspan="4" class="text-center">
              No se encontraron plantillas.
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="relative-graph" style="min-height: 350px;" *ngIf="loadingData">
      <div class="absolute-loading">
        <span class="display-5 text-center">
          <app-loading-animation [height]="'3rem'"></app-loading-animation>
          Cargando...
        </span>
      </div>
    </div>

  </div>
</div>